export const OVERRUN_GRACE_SECONDS = 300;

/**
 * Formats a countdown value in seconds.
 *
 * Positive values render as `M:SS` (remaining time).
 * Zero renders as `0:00`.
 * Negative values render as `+M:SS over` to signal overrun past the limit.
 */
export function formatTimer(totalSeconds: number): string {
  if (totalSeconds >= 0) {
    const m = Math.floor(totalSeconds / 60);
    const s = totalSeconds % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
  }
  const over = Math.abs(totalSeconds);
  const m = Math.floor(over / 60);
  const s = over % 60;
  return `+${m}:${s.toString().padStart(2, '0')} over`;
}
